import { render, staticRenderFns } from "./RoleMenuItem.vue?vue&type=template&id=304e1fca&scoped=true"
import script from "./RoleMenuItem.vue?vue&type=script&lang=js"
export * from "./RoleMenuItem.vue?vue&type=script&lang=js"
import style0 from "./RoleMenuItem.vue?vue&type=style&index=0&id=304e1fca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304e1fca",
  null
  
)

export default component.exports